import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal from "sweetalert2";
import { CompanyService } from "src/app/services/company.service";
import { UserManagementService } from "src/app/services/user-management.service";
import { NetworkService } from "src/app/services/network.service";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { CheckboxCellComponent } from "src/app/components/shared/ag-grid/cell-renderers/checkbox-cell.component";
import { EmailValidation, MobileNumberValidation } from "src/app/models/validator";
import { CheckboxCellSelectComponent } from "src/app/components/shared/ag-grid/cell-renderers/checkbox-select-cell.component";
import { CustomerService } from "src/app/services/customer.service";
import { AppCoreService } from "src/app/services/app-core.service";
import { Title } from "@angular/platform-browser";
import { finalize, forkJoin, lastValueFrom, take } from "rxjs";
import { Utilities } from "src/app/models/utilities";
import { NgSelectComponent } from "@ng-select/ng-select";

@Component({
  selector: 'app-editusers',
  templateUrl: './editusers.component.html',
  styleUrls: ['./editusers.component.scss']
})

export class EditUsersComponent implements OnInit, AfterViewInit {
  @ViewChild('companyRef') companyRef!: NgSelectComponent;
  @ViewChild('customerRef') customerRef!: NgSelectComponent;
  userid: any;
  userForm: FormGroup;
  isFormSubmitted = false;
  userGroupList: any[];
  roleList: any[];
  filteredRoleList: any[];
  deviceTypeList: any[];
  serviceCenterList: any[];
  loginTypeList: any[];
  selectedServiceCenterData: any[] = [];
  companyList: any[];
  customerList: any[];
  hidePassword = true;
  hideConfirmPassword = true;
  selectedLoginType = '';
  selectedGroupType: any;
  userData: any;
  isCustomerType = false;
  isSystemType = false;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;

  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 4,
    // domLayout: 'autoHeight'
    rowSelection: 'multiple',
    suppressRowClickSelection: true
  }
  resServiceCenters: any;
  serviceCenterColumnDefs = [
    { cellRenderer: CheckboxCellSelectComponent, maxWidth: 40 },
    { headerName: 'Code', field: 'code', maxWidth: 120 },
    { headerName: 'Name', field: 'name', filter: true },
    { headerName: 'Default', field: 'isdefault', maxWidth: 80, cellRenderer: CheckboxCellComponent }
  ];

  serviceCenterRowData: any[] = [];
  selectedDeviceType = '';
  useEnterKey: any;
  serviceCenterId;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private ngxLoaderService: NgxUiLoaderService,
    private networkService: NetworkService,
    private companyService: CompanyService,
    private userManagementService: UserManagementService,
    private customerService: CustomerService,
    private appCoreService: AppCoreService,
    private titleService: Title,
    public utilities: Utilities,
  ) {
    titleService.setTitle('Users');
    this.context = {
      componentParent: this,
      componentName: 'EditUsersComponent',
    }
  }

  async ngOnInit() {
    this.userData = this.appCoreService.GetUserData();
    this.useEnterKey = !this.userData.metaInfo.tabbasedtemplate;

    this.loginTypeList = [
      { id: 1, name: 'Client' },
      { id: 2, name: 'Customer' },
      // { id: 3, name: 'Vendor' }
    ];
    this.deviceTypeList = [
      { id: 1, name: 'All' },
      { id: 2, name: 'Web' },
      { id: 3, name: 'Mobile' }
    ];
    this.selectedLoginType = this.loginTypeList[0].name;
    this.selectedDeviceType = this.deviceTypeList[1].name;
    this.userForm = this.formBuilder.group({
      ddlGroups: [null, Validators.compose([Validators.required])],
      ddlRoles: [null, Validators.compose([Validators.required])],
      ddlLoginType: [1, Validators.compose([Validators.required])],
      ddlDeviceType: [1, Validators.compose([Validators.required])],
      ddlCompany: [null, Validators.compose([Validators.required])],
      ddlCustomer: [null],
      txtUserName: [null, Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern(/^[a-zA-Z0-9- ]*$/)])],
      txtEmailId: [null, Validators.compose([Validators.required, EmailValidation, Validators.maxLength(100)])],
      txtMobileNo: [null, MobileNumberValidation],

      ddlServiceCenter: [null],
      txtStatus: ['true'],

    },

    );

    this.userid = this.route.snapshot.params['id'];
    this.isCustomerType = this.userData.accessType === 'Customer' ? true : false;
    this.isSystemType = this.userData.accessType === 'System';
    this.serviceCenterId = this.userData.selectedServiceCenter;

    this.loadDataFromAPI();
    this.checkPermission();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.useEnterKey && this.utilities.focusFirstElement(this.userForm);
    }, 300); 
  }

  focusOnLoginType(){
    setTimeout(() => {
      this.selectedLoginType === 'Client'? this.companyRef.focus(): this.customerRef.focus()
    }, 300);
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Users');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  preventBlanckSpace(event: any, FormControlName: string) {
    this.userForm.get(FormControlName)?.setValue(event.target.value.replace(/\s/g, ''), { emitEvent: false })
  }

  loadDataFromAPI() {
    try {
      forkJoin({
        usergroups: this.userManagementService.GetAllUserGroups({ groupid: this.userData.groupId }),
        roles: this.userManagementService.GetAllRoles(),
        companies: this.companyService.GetAll({ scid: this.serviceCenterId, isactive: true }),
        servicecenters: this.networkService.GetAllServiceCenters(),
        customers: this.customerService.GetAll({ scid: this.serviceCenterId, isactive: true })
      }).pipe(
        finalize(() => { 
          this.bindUser();
        })
      ).subscribe((val) => {
        let selectedCompany;
        if (val.usergroups?.success) {
          this.userGroupList = val.usergroups.data;
        }

        if (val.roles?.success) {
          this.roleList = val.roles.data;
        }

        if (val.companies?.success) {
          this.companyList = val.companies.data;
        }

        if (val.servicecenters?.success) {
          this.serviceCenterList = val.servicecenters.data.map(sc => ({
            ...sc, isDisabled: !sc.isactive
          }));
        }

        if (val.customers?.success) {
          this.customerList = val.customers.data;
        }

        if (this.isCustomerType) {
          const customerGroup = this.userGroupList?.find(item => item.name == "Customer Admin");
          this.userForm.get('ddlGroups').setValue(customerGroup?.id);
          this.userForm.get('ddlGroups').disable();
          this.onUserGroupChange(customerGroup);

          this.loginTypeList = this.loginTypeList
            .filter(item => item.name == 'Customer')
            .map(item => ({ id: 1, name: item.name }));
          this.selectedLoginType = this.loginTypeList[0].name;

          if (this.customerList?.length) {
            this.userForm.get('ddlCustomer').setValue(this.customerList.find(x => x.id === this.userData?.metaInfo?.customerid)?.id);
            this.userForm.get('ddlLoginType').disable();
            this.userForm.get('ddlCustomer').disable();
          };

          if (this.isCustomerType) {
            this.loginTypeList = this.loginTypeList.filter(item => item.name == 'Customer').map((item) => ({ id: 1, name: item.name }));
            this.selectedLoginType = this.loginTypeList[0].name;
            this.customerList?.length ? (
              this.userForm.get('ddlCustomer').setValue(this.customerList.find(x => x.id === this.userData?.metaInfo?.customerid)?.id),
              this.userForm.get('ddlCustomer').disable(),
              this.userForm.get('ddlLoginType').disable()
            )
              : null;
          }
        };

        if (this.isSystemType) {
          this.loginTypeList = this.loginTypeList.filter(item => item.name == 'Client').map((item) => ({ id: 1, name: item.name }));
        }
      });

    } catch (e) {
      console.error(e);
    }
  }


  async bindUserGroups() {
    try {
      const res = await lastValueFrom(this.userManagementService.GetAllUserGroups());
      if (res?.success) {
        this.userGroupList = res?.data;
        // if (this.isCustomerType) {
        //   this.userGroupList = res?.data.find(x=>x.name === 'Customer Admin');
        //   this.userForm.get('ddlGroups').setValue([{value: this.userGroupList[0]?.id, disabled: true}]);
        // }
        const customer = this.userGroupList?.find((item) => item.name == "Customer Admin");
        if (this.isCustomerType) {
          this.userForm.get('ddlGroups').setValue(customer?.id);
          this.userForm.get('ddlGroups').disable();
          this.onUserGroupChange(customer);
        }
      }

    } catch (e) {
      console.error(e);
    }

  }

  async bindRoles() {
    try {
      const res = await lastValueFrom(this.userManagementService.GetAllRoles());
      this.roleList = res && res?.success && res?.data ? res.data : null;
    } catch (e) {
      console.log(e);
    }
  }

  async bindServiceCenter() {
    try {
      const res = await lastValueFrom(this.networkService.GetAllServiceCenters());
      if (res && res?.success) {
        this.resServiceCenters = res?.data;
        if (this.userData.servicecenters) {
          this.resServiceCenters = res?.data.filter(sc =>
            this.userData.servicecenters?.some(x => x.id === sc.id)
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  bindServiceCenters(inputObj: any, forCompany = false) {
    try {
      if (!forCompany || !inputObj) return;

      let scList = [...new Map(
        inputObj.flatMap(c => c.servicecenters || [])
          .map(sc => [sc, this.serviceCenterList.find(x => x.id === sc)])
      ).values()].filter(Boolean); // Remove duplicates and invalid entries

      // Filter service centers if the user is not a system user
      if (this.appCoreService.GetUserData().accessType !== 'System') {
        const allocatedSCs = this.appCoreService.GetUserData()?.servicecenters || [];
        scList = scList.filter((sc: any) => allocatedSCs.some(y => sc?.id === y.id));
      }

      this.serviceCenterRowData = scList;
    } catch (e) {
      console.error(e);
    }
  }

  bindCustomer() {
    this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter }).subscribe((res) => {
      if (res && res?.success) {
        this.customerList = res.data;
      }
    })
  }


  bindUser() {
    this.ngxLoaderService.start();
    const type = 'u';
    this.userManagementService.GetUserById(this.userid, type).subscribe((res) => {
      if (res) {
        if (res.success) {
          const [resData] = res.data;
          // console.log('resData', resData);
          this.selectedLoginType = resData?.info?.clienttype;
          this.ngxLoaderService.stop();
          this.userForm.patchValue({
            ddlGroups: resData?.roles.groupid || null,
            // ddlRoles: resData?.roles.id,
            ddlLoginType: this.loginTypeList.filter(x => x.name === resData?.info.clienttype)[0]?.id,
            devicetype: this.selectedDeviceType,
            ddlCompany: resData?.info?.companies,
            ddlCustomer: resData?.info?.customerid,
            txtUserName: resData?.info.username,
            txtEmailId: resData?.info.emailid,
            txtMobileNo: resData?.info.mobile,
            // txtPassword: '',
            // txtConfirmPassword: '',
            // ddlServiceCenter: '',
            txtStatus: resData?.info.status
          });

          let selectedCompanies = this.companyList.filter(company =>
            resData?.info?.companies.includes(company.id)
          );

          if (selectedCompanies?.length) {
            this.bindServiceCenters(selectedCompanies, true);
          }

          if (resData?.info && this.serviceCenterRowData?.length) {
            this.onUserGroupChange({ id: resData?.roles.groupid });
            this.userForm.get('ddlRoles').setValue(resData?.roles.id);

            this.serviceCenterRowData = this.serviceCenterRowData.map(serviceCenter => ({
              ...serviceCenter,
              active: resData?.info.servicecenters?.find(x => x.id === serviceCenter.id)?.active,
              isdefault: resData?.info.servicecenters?.find(x => x.id === serviceCenter.id)?.isdefault
            })).sort((a, b) =>
              // Sort by `isdefault` first, then by `active`
              (b.isdefault ? 1 : 0) - (a.isdefault ? 1 : 0) || (b.active ? 1 : 0) - (a.active ? 1 : 0)
            );

            this.selectedServiceCenterData = this.serviceCenterRowData
              .filter(item => item.active).map(({ id, active, isdefault, code, name }) => ({ id, active, isdefault, code, name }));
          }
        }
        this.ngxLoaderService.stop();
      }
    });
  }

  onCheckBoxChange(event) {
    if (event.checked && event?.rowdata?.id) {
      // Check for duplicates and add if not present
      this.selectedServiceCenterData ||= [];
      if (!this.selectedServiceCenterData.some(item => item.id === event.rowdata.id)) {
        this.selectedServiceCenterData.push({ id: event.rowdata.id, isdefault: true, active: true });
      }

      // Update grid without disturbing other rows' active status
      this.serviceCenterRowData = this.serviceCenterRowData.map(serviceCenter =>
        serviceCenter.id === event.rowdata.id
          ? { ...serviceCenter, active: true, isdefault: true }
          : { ...serviceCenter, isdefault: false }
      );

      // Take objects from grid to update selectedServiceCenterData
      this.selectedServiceCenterData = this.serviceCenterRowData
        .filter(item => this.selectedServiceCenterData.some(selectedItem => selectedItem.id === item.id))
        .map(({ id, active, isdefault, code, name }) => ({ id, active, isdefault, code, name }));
    }
  }


  onCheckSelectBoxChange(event) {
    const rowData = this.serviceCenterRowData?.find(x => x?.id === event?.rowdata?.id);
    if (event.checked) {
      if (event?.rowdata?.id) {
        const selectedServiceCenterIndex = this.selectedServiceCenterData.findIndex(x => x.id === rowData.id);
        if (selectedServiceCenterIndex === -1) {
          this.selectedServiceCenterData.push(
            {
              id: rowData.id,
              code: rowData.code,
              name: rowData.name,
              active: true,
              isdefault: event?.rowdata?.isdefault || false
            }
          );
        } else {
          this.selectedServiceCenterData[selectedServiceCenterIndex].id = rowData.id;
          this.selectedServiceCenterData[selectedServiceCenterIndex].code = rowData.code;
          this.selectedServiceCenterData[selectedServiceCenterIndex].name = rowData.name;
          this.selectedServiceCenterData[selectedServiceCenterIndex].active = true;
          this.selectedServiceCenterData[selectedServiceCenterIndex].isdefault = event?.rowdata?.isdefault || false;
        }
      }
    } else {
      const selectedServiceCenterIndex = this.selectedServiceCenterData.findIndex(x => x.id === rowData.id);
      if (selectedServiceCenterIndex !== -1) {
        this.selectedServiceCenterData.splice(selectedServiceCenterIndex, 1);
      }
    }
    this.serviceCenterRowData = this.serviceCenterRowData.map(serviceCenter => ({
      ...serviceCenter,
      active: this.selectedServiceCenterData.find(x => x.id === serviceCenter.id)?.active,
      isdefault: this.selectedServiceCenterData.find(x => x.id === serviceCenter.id)?.isdefault
    }));

  }



  updateUser() {
    this.isFormSubmitted = true;
    // this.updatePasswardValidation();
    // Object.keys(this.userForm.controls).forEach(key => {
    //   const control = this.userForm.get(key);
    //   if (control && control.invalid) {
    //     console.log('invalid-key',key);
    //   }
    // });
    if (this.userForm.valid) {
      // const serviceCenterIdsArray = this.userForm.get('ddlServiceCenter').value;
      // let inputPassword = this.userForm.get('txtPassword').value?.trim();
      // let hashedPassword = null;
      // if (inputPassword) {
      //   hashedPassword = md5(inputPassword);
      // }

      const reqObj = {
        id: this.userid,
        usergroupid: this.userForm.get('ddlGroups').value,
        roleid: this.userForm.get('ddlRoles').value,
        // usergroup: this.selectedGroupType,
        logintype: this.selectedLoginType,
        devicetype: this.selectedDeviceType,
        username: this.userForm.get('txtUserName').value,
        emailid: this.userForm.get('txtEmailId').value,
        mobileno: this.userForm.get('txtMobileNo').value,
        // password: hashedPassword,
        // serviceids: serviceCenterIdsArray.map(serviceCenter => serviceCenter.id),
        customerid: this.userForm.get('ddlCustomer').value,
        servicecenterids: this.selectedServiceCenterData,
        companyids: this.userForm.get('ddlCompany').value,
        isactive: this.userForm.get('txtStatus').value
      }
      // Check if any object in the array has isdefault set to true
      const hasDefault = this.selectedServiceCenterData.some(obj => obj.isdefault);
      if (!hasDefault) {
        this.openWarningDialog('At least one service center should be default.');
        return;
      }
      // console.log('reqObj', reqObj.servicecenterids);
      this.ngxLoaderService.start();
      this.userManagementService.Update(reqObj).subscribe((res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.openConfirmationDialog('Record Updated Successfully.');
        } else if (res && !res.success) {
          this.ngxLoaderService.stop();
          this.openWarningDialog(res.message)
        }
      });
    }
  }


  showPassword(value?: any) {
    if (value == 'pass') {
      this.hidePassword = !this.hidePassword;
    } else {
      this.hideConfirmPassword = !this.hideConfirmPassword;
    }
  }

  onUserGroupChange(data: any) {
    // console.log(data);
    this.filteredRoleList = [];
    this.userForm.get('ddlRoles').reset();
    if (data) {
      this.filteredRoleList = this.roleList?.filter(x => x.groupid === data.id);
      this.filteredRoleList?.length > 0 ? this.userForm.get('ddlRoles').setValue(this.filteredRoleList[0]?.id) : null;
    }
  }

  onLoginTypeChange(val: any) {
    this.selectedLoginType = val.name;
    if (val?.name === this.loginTypeList[1].name) {
      this.userForm.get('ddlCustomer').setValidators([Validators.required]);
      this.userForm.get('ddlCompany').clearValidators();
    } else if (val?.name === this.loginTypeList[0].name) {
      this.userForm.get('ddlCustomer').clearValidators();
      this.userForm.get('ddlCompany').setValidators([Validators.required]);
    }
    this.userForm.get('ddlCustomer').updateValueAndValidity();
    this.userForm.get('ddlCompany').updateValueAndValidity();
  }

  onCompanyChange(val: any) {
    this.bindServiceCenters(val, true);
  }

  onDeviceTypeChange(val: any) {
    this.selectedDeviceType = val?.name;
  }

  formateDate(date?: any) {
    const inputDate = date != null || undefined ? new Date(date) : new Date();
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
    const day = inputDate.getDate().toString().padStart(2, '0');
    const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
    const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
    const ss = inputDate.getSeconds() < 10 ? ('0' + inputDate.getSeconds()) : inputDate.getSeconds();
    const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
    const dateString = `${year}-${month}-${day}`;
    return { dateString, dateTimeString };
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const res = await Swal.fire({
      title: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (res.isConfirmed) {
      this.router.navigate(['/iam/users']);
    }
  }

  openWarningDialog(msg: any) {
    Swal.fire({
      title: 'Warning',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  resetForm(): void {
    this.userForm.reset();
    this.isFormSubmitted = false;
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }
}
